import styled from 'styled-components';

export const SubmoduleLayoutStyledComponent = styled.div`
    width: 100%;
    height: 100%;

    .content {
        margin: 16px 24px;
    }
`;
